import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import classNames from 'classnames'

import { getUser } from 'data/users/selectors'
import RoutesHelper from 'helpers/RoutesHelper'
import { trackNoteClicked } from 'data/analytics/actions'
import { getNoteActivityStatus } from 'data/activityRegistry/selectors'
import { ACTIVE } from 'data/activityRegistry/record'

import Timeago from 'components/Utils/Timeago'
import { NotesDirectoryLayoutItem } from './Layout'

export default function ContainerItem({ note }) {
  const dispatch = useDispatch()
  const onClickNote = React.useCallback(
    () => {
      dispatch(trackNoteClicked({ source: 'directory' }))
    },
    [dispatch]
  )

  return (
    <Link
      onClick={onClickNote}
      to={RoutesHelper.noteChannelShow({
        channelId: note.channelId,
        noteId: note.id,
      })}
    >
      <NotesDirectoryLayoutItem
        note={note}
        onClick={onClickNote}
        renderTitle={ContainerItemTitle}
        renderExtra={ContainerItemExtra}
      />
    </Link>
  )
}

const ContainerItemTitle = ({ note }) => {
  const hasActivity = useSelector(
    state => getNoteActivityStatus(state, note) === ACTIVE
  )
  return (
    <span className={classNames({ 'font-weight-bold': hasActivity })}>
      {note.title || 'Untitled'}
    </span>
  )
}

const ContainerItemExtra = ({ note }) => {
  const byLabel = useSelector(state => {
    const user = getUser(state, note.lastActivityBy)
    if (!user) {
      return ''
    }
    return ` by @${user.username}`
  })

  return (
    <span>
      <Timeago date={note.get('lastActivityAt')} />
      {byLabel}
    </span>
  )
}
